import axios from "axios";
import SonicTerm, { SonicTermData } from "../../../common/classes/SonicTerm";
import { getAPIRoot } from "../../../utils/GeneralUtils";
import APIRoutes from "../../APIRoutes";

/**
 * getPickupTerms
 *
 * Fetches pickup term data.
 *
 * @returns An array of terms.
 */

export const getFeaturedTerms = async (type: string) => {
  try {
    const res = await axios.get(getAPIRoot(APIRoutes.get.featured_term), {
      params: {
        sonic_taxonomy_type: type,
      },
    });

    if (res.data.result == true) {
      const terms: Array<SonicTermData> = [];

      res.data.message.terms.forEach((t: any) => {
        const term = SonicTerm.parseFromAPIResponse(t);
        terms.push(term);
      });

      return { terms: terms };
    } else {
      return null;
    }
  } catch (e) {
    return null;
  }
};
